import {Injectable} from "@angular/core";
import {Http, RequestOptions, Response} from "@angular/http";
import {UtilService} from "../util";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import {FacilityDTO, FacilityModel} from "../../models";
import {SearchCriteria} from "../../models/search-criteria.model";

@Injectable()
export class FacilityService {
  URL: string = "/facilities";

  constructor(private http: Http, private utilService: UtilService) {
  }

  private formatBody(facility: FacilityModel): any {
    return new FacilityDTO(facility);
  }

  getSystemFacilities(searchCriteria: SearchCriteria = null,
                      showInactive: boolean = false): Observable<Array<FacilityModel>> {
    if (!searchCriteria) {
      searchCriteria = new SearchCriteria()
    }
    const params = {
      page: searchCriteria.PageNumber,
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      q: searchCriteria.SearchTerm,
      show_all: showInactive ? "true" : "false"
    };
    let queryParams = this.utilService.setQueryParams(params);

    return this.get(this.getFacilitiesUrl(true), queryParams).map((facilities: FacilityDTO[]) => {
      return facilities.map(facility => new FacilityModel(facility))
    });
  }

  getFacilityHeader(searchCriteria: SearchCriteria) {
    return this.http
      .get(this.getFacilitiesUrl(true), {})
      .map((res: Response) => {
        return res;
      })
      .catch(this.utilService.handleError);
  }

  getFacilities(searchCriteria: SearchCriteria = null,
                showInactive: boolean = false, system: boolean = false): Observable<Array<FacilityModel>> {
    if (!searchCriteria) {
      searchCriteria = new SearchCriteria()
    }
    const params = {
      page: searchCriteria.PageNumber,
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      search: searchCriteria.SearchTerm,
      show_all: showInactive ? "true" : "false"
    };
    let queryParams = this.utilService.setQueryParams(params);

    return this.get(this.getFacilitiesUrl(system), queryParams).map((facilities: FacilityDTO[]) => {
      return facilities.map(facility => new FacilityModel(facility))
    });
  }

  getFacilitiesUrl(system: boolean) {
    return system ? '/system_facilities' : '/core/facilities'
  }

  getLocationById(id: string, system: boolean) {

    return this.getById(this.getFacilitiesUrl(system), id).map(facility => new FacilityModel(facility));
  }

  updateFacility(facility: FacilityModel) {
  return this.update(`/system_facilities/${facility.id}`, this.formatBody(facility));
  }

  checkLocationExists(facility: FacilityModel): Observable<boolean> {
    let queryParams = this.utilService.setQueryParams({
      name: facility.name,
      address1: facility.address1,
      city: facility.city,
      state: facility.state,
      postalCode: facility.zip,
      id: facility.id
    });
    let options = new RequestOptions({params: queryParams});
    return this.http
      .get(this.getFacilitiesUrl(true) + "/exists", options)
      .map(
        (res: Response) =>
          (this.utilService.outputParser(res) || {}).Exists || false
      )
      .catch(this.utilService.handleError);
  }

  createFacility(facility: FacilityModel) {
    return this.create(this.getFacilitiesUrl(true), this.formatBody(facility));
  }

  private get<T>(url: string, queryParams?: any): Observable<T> {
    let options = new RequestOptions({params: queryParams});
    return this.http
      .get(url, options)
      .map((res: Response) => {
        return this.parseResponse(res);
      })
      .catch(this.utilService.handleError);
  }

  private getById(url: string, id: any, queryParams?: any) {
    url += "/" + id;
    let options = new RequestOptions({params: queryParams});

    return this.http
      .get(url, options)
      .map((res: Response) => {
        return this.parseResponse(res);
      })
      .catch(this.utilService.handleError);
  }

  private create<T>(url: string, body: T): Observable<T> {
    return this.http
      .post(url, body)
      .map((res: Response) => {
        return this.parseResponse(res);
      })
      .catch(this.utilService.handleError);
  }

  private update<T>(url: string, body: T): Observable<T> {
    return this.http
      .put(url, body)
      .map((res: Response) => {
        return this.parseResponse(res);
      })
      .catch(this.utilService.handleError);
  }

  private parseResponse(param) {
    let body = this.utilService.outputParser(param);
    if (Array.isArray(body)) {
      return body.map(facility => new FacilityModel(facility));
    }

    return new FacilityModel(body);
  }

  setVisibility(facility: FacilityModel, visible: boolean) {
    let data = {
      visible
    };
    const url = this.getFacilitiesUrl(true) + `/${facility.Id}`;
    return this.http.patch(url, data)
      .map((res: Response) => {
        return this.parseResponse(res);
      })
      .catch(this.utilService.handleError);
  }

  deactivateFacility(facility: FacilityModel) {
    return new Observable(observer => {
      observer.next();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/location/location.service.ts